import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { Section } from 'legacyComponents/layout/section';
import { CenteredButtonWrapper, ButtonShowMore } from 'apps/components/shared';
import { NoDataCard } from 'legacyComponents/cards/types/noData';
import { Button } from 'components';

@withNamespaces()
@observer
export class CardSection extends React.Component {
  render() {
    const {
      isWhitelabel,
      isCollection,
      isChannel,
      spaceType,
      owner,
      ownerName,
      cardApp,
      index,
      updateHeader,
      CardComponent,
      noDataCardType,
      title,
      noCount,
      subTitle,
      tooltip,
      noSort = false,
      first,
      last,
      invisible,
      createHandler,
      introComponent,
      initiative,
      showButton = true,
      noMarginTop,
      actions,
      gridColumns,
      gridGap,
      intercomTarget = '',
      maxItems,
      showAllRouteName,
      showAllRouteParams,
      canShowNoDataCard,
    } = this.props;
    const cards = [];
    const callToActions = [];
    if (cardApp.length === 0 && !cardApp.manager.loading) {
      if (canShowNoDataCard || owner || initiative || spaceType) {
        return (
          <Section
            title={title}
            tooltip={tooltip}
            index={index}
            updateHeader={updateHeader}
            subTitle={subTitle}
            last={last}
            sectionConfig={cardApp}
            createHandler={owner || isChannel ? createHandler : ''}
            gridColumns={0}
            gridGap={gridGap}
            noSort
            noCount
          >
            <NoDataCard
              type={noDataCardType}
              owner={owner}
              ownerName={ownerName}
              isChannel={isChannel}
              isCollection={isCollection}
              isWhitelabel={isWhitelabel}
              spaceType={spaceType}
            />
          </Section>
        );
      }
      return null;
    }

    // eslint-disable-next-line
    for (const [cardNo, cardObj] of cardApp.entries()) {
      if (cards.length >= maxItems) break;
      cards.push(
        <CardComponent
          key={cardObj.id}
          cardObject={cardObj}
          cardNo={cardNo}
          cardColumns={cardApp.cardLayout.layoutSpec.cardColumns}
          cardApp={cardApp}
        />,
      );
    }
    if (cardApp.manager.loadingMore) {
      let numberOfNoDataItems = cardApp.manager.variables.batchSize;
      if (maxItems > 0)
        numberOfNoDataItems = Math.min(
          maxItems,
          cardApp.manager.variables.batchSize,
        );
      // eslint-disable-next-line
      for (let i = 0; i < numberOfNoDataItems; i++) {
        cards.push(
          <CardComponent
            cardObject={null}
            key={`no-data-${i}`}
            cardNo={i}
            cardColumns={cardApp.cardLayout.layoutSpec.cardColumns}
          />,
        );
      }
    }

    let bottomButton = null;
    if (!cardApp.manager.loading) {
      if (showAllRouteName && maxItems < cardApp.length) {
        bottomButton = (
          <CenteredButtonWrapper>
            <Link name={showAllRouteName} params={showAllRouteParams}>
              <Button
                size='default'
                variant='primary'
                outline
                text='Show all'
                icon='arrow_right'
                iconPosition='right'
              />
            </Link>
          </CenteredButtonWrapper>
        );
      } else if (cardApp.manager.hasNextPage && showButton) {
        bottomButton = (
          <ButtonShowMore
            size='default'
            variant='primary'
            outline
            text={<Trans>Show more</Trans>}
            onClick={() => cardApp.manager.loadMore()}
          />
        );
      }
    }

    return (
      <>
        {introComponent || ''}
        <Section
          title={title}
          tooltip={tooltip}
          index={index}
          updateHeader={updateHeader}
          subTitle={subTitle}
          createHandler={owner || isChannel ? createHandler : ''}
          sectionConfig={cardApp}
          invisible={invisible}
          first={first}
          last={last}
          noSort={noSort || cardApp.length <= gridColumns}
          noCount={noCount}
          noMarginTop={noMarginTop}
          actions={actions}
          gridColumns={gridColumns}
          gridGap={gridGap}
          intercomTarget={intercomTarget}
        >
          {cards}
          {callToActions}
        </Section>
        {bottomButton}
      </>
    );
  }
}

CardSection.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  index: PropTypes.number,
  gridColumns: PropTypes.number,
  gridGap: PropTypes.string,
  updateHeader: PropTypes.bool,
  subTitle: PropTypes.string,
  createHandler: PropTypes.func,
  last: PropTypes.bool,
  first: PropTypes.bool,
  owner: PropTypes.bool,
  isCollection: PropTypes.bool,
  isChannel: PropTypes.bool,
  isWhitelabel: PropTypes.bool,
  spaceType: PropTypes.string,
  ownerName: PropTypes.string,
  cardApp: PropTypes.object,
  CardComponent: PropTypes.elementType,
  noDataCardType: PropTypes.string,
  invisible: PropTypes.bool,
  introComponent: PropTypes.func,
  t: PropTypes.func,
  showButton: PropTypes.bool,
  noSort: PropTypes.bool,
  noCount: PropTypes.bool,
  initiative: PropTypes.object,
  noMarginTop: PropTypes.bool,
  actions: PropTypes.element,
  intercomTarget: PropTypes.string,
  maxItems: PropTypes.number,
  showAllRouteName: PropTypes.string,
  showAllRouteParams: PropTypes.object,
  canShowNoDataCard: PropTypes.bool,
};
